import { Input, Label } from "reactstrap";
import { handleFormChange } from "../../../components/modals/EditableTable";
import { useTranslation } from "react-i18next";
import InfoTip from "../../../components/InfoTip";

/**
 * Carte Notifications – maquette : deux cases à cocher avec icône info.
 */
const ZoneSettingsNotifications = ({ formData, setFormData }) => {
  const { t } = useTranslation();

  const options = [
    {
      name: "alertForAnomaly",
      labelKey: "containerSettings.alertSortingError",
      tip: t("Enable email and SMS notifications in case of sorting errors"),
    },
    {
      name: "alertForFilling",
      labelKey: "containerSettings.alertFillingThreshold",
      tip:
        t(
          "Enable email and SMS notifications from the defined fill level threshold",
        ) +
        (formData.limitFillingLevel
          ? ` (${formData.limitFillingLevel}%).`
          : "."),
    },
  ];

  return (
    <div className="flex flex-col w-full">
      {options.map((opt) => (
        <div key={opt.name} className="zone-settings__checkbox-row">
          <div className="zone-settings__checkbox-wrap">
            <Input
              type="checkbox"
              id={opt.name}
              name={opt.name}
              checked={!!(formData[opt.name] ?? false)}
              onChange={(e) => handleFormChange(e, formData, setFormData)}
              className="zone-settings__checkbox"
            />
          </div>
          <div className="flex-1 min-w-0 flex items-center gap-1.5">
            <Label
              htmlFor={opt.name}
              className="zone-settings__checkbox-label mb-0 ml-3"
            >
              {t(opt.labelKey)}
            </Label>
            <InfoTip nudgeY={1}>{opt.tip}</InfoTip>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ZoneSettingsNotifications;
